export async function pasteNodeStyle(nodes) {
    await this.execute(
        () => this.actions.pasteNodeStyle(nodes)
    )
}
